<form [formGroup]="form" (ngSubmit)="onSubmit()">
	<wrapper-dialog headlining="Filter">
		<ng-container content>
			<mat-form-field appearance="outline">
				<mat-label>Enter a date range</mat-label>
				<mat-date-range-input formGroupName="dateRange" [rangePicker]="picker">
					<input matStartDate formControlName="start" placeholder="Start date" />
					<input matEndDate formControlName="end" placeholder="End date" />
				</mat-date-range-input>
				<mat-datepicker-toggle matIconSuffix [for]="picker" />
				<mat-date-range-picker #picker />

				@if (form.controls.dateRange.controls.start.hasError('matStartDateInvalid')) {
					<mat-error>Invalid start date</mat-error>
				}
				@if (form.controls.dateRange.controls.end.hasError('matEndDateInvalid')) {
					<mat-error>Invalid end date</mat-error>
				}
			</mat-form-field>
			@if (!isDateRange()) {
				<div class="container">
					<mat-checkbox color="primary" formControlName="searchByParked">
						On Hand
					</mat-checkbox>
					<mat-checkbox color="primary" formControlName="searchByTempCheckout">
						Out & Returning
					</mat-checkbox>
					<mat-checkbox color="primary" formControlName="searchByCheckout">
						Checked Out
					</mat-checkbox>
				</div>
			}
		</ng-container>
		@if (isTicketTransactionsPage()) {
			<ng-container extra-action>
				<mat-checkbox
					color="primary"
					[formControl]="overnight"
					[style.marginRight]="'auto'"
				>
					Overnight
				</mat-checkbox>
			</ng-container>
		}
		<button type="submit" actioner-raised color="main" [disabled]="!form.valid" action>
			Confirm
		</button>
	</wrapper-dialog>
</form>
